module.exports = __webpack_public_path__ + "assets/img/CouldntFind@2x.754bdd8a.png";